import React from "react";
import { IPreviewAttachmentDialogProps } from "./PreviewAttachmentDialog.types";
import { Dialog } from "../../../../components/Dialogs/Dialog";
import { Box, Stack, Typography } from "@mui/material";
import { CSS_CONSTANTS } from "../../../../constants/cssConstants";

export const PreviewAttachmentDialog: React.FC<
  IPreviewAttachmentDialogProps
> = ({ preview, open, onClose }) => {
  return (
    <Dialog
      open={open}
      title={preview.name}
      onClose={onClose}
      size="xl"
      fullWidth
    >
      <Stack>
        {preview.contentType.startsWith("image/") ? (
          <Box
            component="img"
            src={preview.url}
            alt={preview.name}
            sx={{ maxWidth: "100%", maxHeight: "600px", objectFit: "contain" }}
          />
        ) : preview.contentType.includes("pdf") ? (
          <iframe
            src={preview.url}
            style={{ width: "100%", height: "600px", border: "none" }}
            title={preview.name}
          />
        ) : (
          <Typography
            variant="body1"
            sx={{
              fontSize: CSS_CONSTANTS.LABEL_VALUE_SIZE,
            }}
            color="text.secondary"
          >
            Preview not available for this file type
          </Typography>
        )}
      </Stack>
    </Dialog>
  );
};
